import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0144',
    ecrans: ['00-2'],
    params: ['temcleint', 'geccleint']
});
